import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { MessageService } from './message.service';

@Injectable({
    providedIn: 'root',
})
export class MessageServiceImpl implements MessageService {
    constructor(private store: Store<State>, private http: HttpClient) {}

    getMessages(organisation: string, actions: string[], status: string[], userId: string, dateStart: string, dateEnd: string): Observable<any> {
        const queryArgs = [];
        if (organisation && organisation !== 'ALL') {
            queryArgs.push(`organisation=${organisation}`);
        }
        if (actions && actions.length > 0) {
            queryArgs.push(`actions=${actions.join(',')}`);
        }
        if (status && status.length > 0) {
            queryArgs.push(`status=${status.join(',')}`);
        }
        if (userId) {
            queryArgs.push(`userId=${userId}`);
        }
        if (dateStart) {
            queryArgs.push(`dateStart=${new DatePipe('en').transform(dateStart, 'YYYY-MM-dd')}`);
        }
        if (dateEnd) {
            queryArgs.push(`dateEnd=${new DatePipe('en').transform(dateEnd, 'YYYY-MM-dd')}`);
        }
        const query = queryArgs.length > 0 ? `?${queryArgs.join('&')}` : '';
        console.log(query);
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/messages${query}`).pipe(map((res) => res))));
    }

    getDiagnostic(): Observable<any> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/messages/diagnostic`).pipe(map((res) => res))));
    }
}

export const MESSAGE_SERVICE_PROVIDER = {
    provide: MessageService,
    useClass: MessageServiceImpl,
};
